import { useQuery } from '@tanstack/react-query';
import { NioshReportService } from '@/infra/services/niosh-report';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetNioshParams {
	organization_id: string;
	company_id: string;
	file_id: string;
}

const Service = NioshReportService.getInstance();

export const useGetNiosh = (params: GetNioshParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_NIOSH_REPORT, params],
		queryFn: () => Service.getNioshReport(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.file_id,
		retry: 0
	});
};

